import moment from 'moment'

export const selectedMonth = (month) => month.find((item) => item.value === moment().format('YYYY-MM'))
